'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');

var actions = {
    setInput: 'SET_INPUT',
    setPage: 'SET_PAGE',
    decrement: 'DECREMENT',
    increment: 'INCREMENT'
};
var initialState = {
    page: 0,
    input: '1'
};
var carouselReducer = function (state, action) {
    var _a, _b;
    var getInputValue = function (page) { return "".concat(page + 1); };
    switch (action.type) {
        case actions.setInput: {
            return tslib.__assign(tslib.__assign({}, state), { input: (_a = action.input) !== null && _a !== void 0 ? _a : '' });
        }
        case actions.setPage: {
            var page = (_b = action.page) !== null && _b !== void 0 ? _b : state.page;
            var input = getInputValue(page);
            return tslib.__assign(tslib.__assign({}, state), { page: page, input: input });
        }
        case actions.increment: {
            var page = state.page + 1;
            var input = getInputValue(page);
            return tslib.__assign(tslib.__assign({}, state), { page: page, input: input });
        }
        case actions.decrement: {
            var page = state.page - 1;
            var input = getInputValue(page);
            return tslib.__assign(tslib.__assign({}, state), { page: page, input: input });
        }
        default: {
            throw new Error("Unhandled action type: ".concat(action.type));
        }
    }
};

exports.actions = actions;
exports.carouselReducer = carouselReducer;
exports.initialState = initialState;
//# sourceMappingURL=carouselReducer.js.map
